import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'section-header',
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./section-header.component.scss'],
  standalone: false,
})
export class SectionHeaderComponent implements OnInit {
  @Input() valid = false;
  @Input() touched = false;
  @Input() compact = false;
  @Input() optional = false;
  @Input() optionalText = '';

  constructor() {}

  ngOnInit() {}
}
